/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Selector,
  Selector$inboundSchema,
  Selector$Outbound,
  Selector$outboundSchema,
} from "./selector.js";

/**
 * The scope slug this grant applies to.
 */
export const Scope = {
  OrgRead: "org:read",
  OrgBlockedRead: "org:blocked_read",
  OrgAdmin: "org:admin",
  OrgBlockedAdmin: "org:blocked_admin",
  ProjectRead: "project:read",
  ProjectBlockedRead: "project:blocked_read",
  ProjectWrite: "project:write",
  ProjectBlockedWrite: "project:blocked_write",
  McpRead: "mcp:read",
  McpBlockedRead: "mcp:blocked_read",
  McpWrite: "mcp:write",
  McpBlockedWrite: "mcp:blocked_write",
  McpConnect: "mcp:connect",
  McpBlockedConnect: "mcp:blocked_connect",
  EnvironmentRead: "environment:read",
  EnvironmentBlockedRead: "environment:blocked_read",
  EnvironmentWrite: "environment:write",
  EnvironmentBlockedWrite: "environment:blocked_write",
  SkillRead: "skill:read",
  SkillBlockedRead: "skill:blocked_read",
  SkillWrite: "skill:write",
  SkillBlockedWrite: "skill:blocked_write",
  AssistantRead: "assistant:read",
  AssistantBlockedRead: "assistant:blocked_read",
  AssistantWrite: "assistant:write",
  AssistantBlockedWrite: "assistant:blocked_write",
  PluginWrite: "plugin:write",
  PluginBlockedWrite: "plugin:blocked_write",
  RiskPolicyEvaluate: "risk_policy:evaluate",
  RiskPolicyBypass: "risk_policy:bypass",
  RiskPolicyBlock: "risk_policy:block",
  ChatRead: "chat:read",
  ChatWrite: "chat:write",
  LogRead: "log:read",
  AgentRead: "agent:read",
  AgentWrite: "agent:write",
  AgentAuthorize: "agent:authorize",
  AgentTransfer: "agent:transfer",
  WorkloadRead: "workload:read",
  WorkloadBlockedRead: "workload:blocked_read",
  WorkloadWrite: "workload:write",
  WorkloadBlockedWrite: "workload:blocked_write",
  OrgDeviceAgentSync: "org:device_agent_sync",
  OrgHooksIngest: "org:hooks_ingest",
} as const;
/**
 * The scope slug this grant applies to.
 */
export type Scope = ClosedEnum<typeof Scope>;

export type RoleGrant = {
  /**
   * The scope slug this grant applies to.
   */
  scope: Scope;
  /**
   * Selector constraints. Null means unrestricted.
   */
  selectors?: Array<Selector> | undefined;
};

/** @internal */
export const Scope$inboundSchema: z.ZodMiniEnum<typeof Scope> = z.enum(Scope);
/** @internal */
export const Scope$outboundSchema: z.ZodMiniEnum<typeof Scope> =
  Scope$inboundSchema;

/** @internal */
export const RoleGrant$inboundSchema: z.ZodMiniType<RoleGrant, unknown> = z
  .object({
    scope: Scope$inboundSchema,
    selectors: z.optional(z.array(Selector$inboundSchema)),
  });
/** @internal */
export type RoleGrant$Outbound = {
  scope: string;
  selectors?: Array<Selector$Outbound> | undefined;
};

/** @internal */
export const RoleGrant$outboundSchema: z.ZodMiniType<
  RoleGrant$Outbound,
  RoleGrant
> = z.object({
  scope: Scope$outboundSchema,
  selectors: z.optional(z.array(Selector$outboundSchema)),
});

export function roleGrantToJSON(roleGrant: RoleGrant): string {
  return JSON.stringify(RoleGrant$outboundSchema.parse(roleGrant));
}
export function roleGrantFromJSON(
  jsonString: string,
): SafeParseResult<RoleGrant, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RoleGrant$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RoleGrant' from JSON`,
  );
}
